<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <router-link :to="{ name: 'AssignmentTermsDashboard' }" class="navbar-brand">Assignment Terms</router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link :to="{ name: 'AffiliatedGroups' }" class="nav-link">Affiliated Groups</router-link>
        </li>
        <b-nav-item-dropdown text="CSV Exports">
          <b-dropdown-item href="#">
            <router-link :to="{ name: 'AssignmentTermsExport' }" class="nav-link">Assignment Terms Export</router-link>
          </b-dropdown-item>
          <b-dropdown-item href="#">
            <router-link :to="{ name: 'ProductCoverageExport' }" class="nav-link">Product Coverage Export</router-link>
          </b-dropdown-item>
          <b-dropdown-item href="#">
            <router-link :to="{ name: 'RemainingContingentsExport' }" class="nav-link">Remaining Contingents Export (Targeting Export)</router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Admin" right v-if="this.isUserAdmin">
          <b-dropdown-item href="#">
            <router-link :to="{ name: 'OptionIdsAdminPanel' }" class="nav-link">Option IDs</router-link>
          </b-dropdown-item>
          <b-dropdown-item href="#">
            <router-link :to="{ name: 'ZipcodesManagement' }" class="nav-link">Zipcodes</router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
      <span class="navbar-text mx-3">
        {{ currentUser.email }}
      </span>
      <div class="btn-group" role="group">
        <button class="btn btn-outline-danger my-2 my-sm-0"
                type="button"
                v-if="isAuthenticated"
                @click="logout()">
                Logout
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import {AUTH_LOGOUT} from '@/store/actions/auth'

export default {
  name: 'Navigation',
  methods: {
    logout () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.replace('/login')
      })
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    currentUser () {
      return this.$store.getters.getProfile
    },
    isUserAdmin () {
      if (this.$store.getters.isProfileLoaded) {
        return this.$store.getters.isAdmin
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
</style>
